<template>
  <div class="home">
   
    <Head></Head>
    <MainPage msg="Welcome to ddjj"/>
    <!-- <MainPage1 msg="Welcome to ddjj"/> -->
    <Foot></Foot>
  </div>

</template>

<script>
// @ is an alias to /src
import MainPage from '@/components/MainPage.vue'
// import MainPage1 from '@/components/MainPage1.vue'


  // 引用头部组件
import Head from '@/components/HeadPage.vue'

import Foot from '@/components/FootPage.vue'

export default {
  name: 'HomeView',
  components: {
    MainPage,Head,Foot
  }
}
</script>
